import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledButton,
  StyledBackButton,
  StyledCloseButton,
  CloseIcon,
  BackIcon
} from './styled';

const Button = ({
  onClick,
  disabled = false,
  variant = 'primary',
  children,
  ...props
}) => {
  return (
    <StyledButton
      onClick={!disabled ? onClick : undefined}
      variant={disabled ? 'disabled' : variant}
      disabled={disabled}
      {...props}
    >
      {children}
    </StyledButton>
  );
};

Button.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  variant: PropTypes.string,
  disabled: PropTypes.bool
};

Button.defaultProps = {
  variant: 'primary',
  disabled: false
};

export default Button;

export const BackButton = ({
  onClick,
  disabled = false,
  variant,
  children,
  ...props
}) => {
  return (
    <StyledBackButton
      onClick={onClick}
      disabled={disabled}
      variant={disabled ? 'disabled' : variant}
      {...props}
    >
      <BackIcon />
      {children}
    </StyledBackButton>
  );
};

BackButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  variant: PropTypes.string,
  disabled: PropTypes.bool
};

BackButton.defaultProps = {
  variant: 'light',
  disabled: false,
  children: 'Back'
};

export const CloseButton = ({ onClick, ...props }) => {
  return (
    <StyledCloseButton onClick={onClick} {...props}>
      <CloseIcon />
    </StyledCloseButton>
  );
};

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
